"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    pickerFrame: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    pickerLabel: {
        textAlign: 'left',
    },
    modalFrame: {
        width: '100%',
        height: '100%',
        backgroundColor: '#1a2b3459',
    },
    modalContent: {
        width: '100%',
        height: '100%',
        padding: 15,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    searchInput: {
        width: '100%',
        height: 50,
        padding: 15,
        backgroundColor: 'white',
        color: '#263238',
    },
    listFrame: {
        flexGrow: 0,
        width: '100%',
        backgroundColor: 'white',
    },
    itemFrame: {
        width: '100%',
        padding: 15,
    },
    itemLabel: {
        fontSize: 14,
        color: '#263238',
    },
};
